import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const LargeArrowIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-large-arrow-icon ${className}`, fill: 'none', height: '27', viewBox: '0 0 30 27', width: '30', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M16.4142 0.585787C15.6332 -0.195263 14.3668 -0.195263 13.5858 0.585787L0.857864 13.3137C0.0768156 14.0948 0.0768156 15.3611 0.857864 16.1421C1.63891 16.9232 2.90524 16.9232 3.68629 16.1421L15 4.82843L26.3137 16.1421C27.0948 16.9232 28.3611 16.9232 29.1421 16.1421C29.9232 15.3611 29.9232 14.0948 29.1421 13.3137L16.4142 0.585787ZM17 27L17 2H13L13 27H17Z', fill: 'white' }) })));
LargeArrowIcon.propTypes = {
    className: propStr(),
};
LargeArrowIcon.defaultProps = {
    className: '',
};
export default LargeArrowIcon;
